<template>
    <div>
        <Header :selected="selected" :channelList="channelList" :changeType="changeType" />
        <Table
            :selected="selected"
            :channelList="channelList"
            :editChannelName="editChannelName"
            :confirmChannelName="confirmChannelName"
            :blur="blur"
            :changeName="changeName"
            :addChanel="addChanel"
            :changeType="changeType"
        />
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '../userChannelElement/Header'
import Table from '../userChannelElement/Table'

export default {
  name: 'Channel',
  meta:{page:true},
  computed: {
        ...mapGetters('user', {
            channelList: 'getChannelList'
        })
  },
  created(){
  	this.$store.dispatch('user/getChannelList');
  },
  methods:  {
      addChanel() {
          this.$store.dispatch('user/addChannel');
      },
      changeType: function (value) {
          this.selected = value;
      },
      editChannelName: function(id) {
          this.$store.dispatch('user/changeChannelEdit', id);
      },
      blur() {
          this.$store.dispatch('user/blur');
      },
      confirmChannelName(id) {
          this.$store.dispatch('user/changeChannelName', {
              channelKey: this.channelList.list.find(s => s.id === id).channelKey,
              name: this.name,
              desc: this.channelList.list.find(s => s.id === id).desc,
            })
      },
      changeName(e) {
          this.name = e.target.value;
      }
  },
  data() {
        return {
            selected: '1',
            name: '',
        }
  },
  components: {
      Header,
      Table
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/Channel.vue